import { TOKEN_EXPIRED } from '@speeki/dictionary';

import { SkipMfaDocument } from '@graphql/generated/graphql';

import { useInitializeSession } from '@services/AuthService/useInitializeSession';

import { useMutation } from '@apollo/client';

export const useLoginAfterSkipMfa = () => {
    const [skipMfa, { error }] = useMutation(SkipMfaDocument, {
        context: {
            notifyOnError: {
                exceptions: [TOKEN_EXPIRED],
            },
        },
    });

    const { initializeSession } = useInitializeSession(skipMfa, true);

    return {
        handleSkipMfa: initializeSession,
        skipMfaError: error,
    };
};
